<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="info">
      <b-navbar-brand href="#">Configuration</b-navbar-brand>
      <b-navbar-nav class="ml-auto">
        <b-button size="sm" variant="info" @click="doClick">
          <img src="img/home.svg" alt="Home" width="16px">
        </b-button>
      </b-navbar-nav>
    </b-navbar>
    <b-container>
      <div style="padding-top: 10px">
        <b-form @submit.prevent="onSubmit">
          <b-form-group id="input-group-2" label="URL:" label-for="url">
            <b-form-input id="url" name="url" v-model="url" placeholder="Enter server URL"/>
            <span class="text-danger">{{ error }}</span>
          </b-form-group>
          <b-button block type="submit" variant="info">Save</b-button>
        </b-form>
      </div>
    </b-container>
  </div>
</template>

<script>
  import validator from 'validator';

  export default {
    name: 'Config',
    data() {
      return {
        url: localStorage.getItem('okm.qrcad.url'),
        error: null
      }
    },
    methods: {
      onSubmit() {
        if (validator.isURL(this.url)) {
          localStorage.setItem('okm.qrcad.url', this.url);
          this.$router.replace('/');
        } else {
          this.error = 'This field should be a valid URL';
        }
      },
      doClick() {
        this.$router.replace('/');
      }
    }
  }
</script>
